<template>
	<div>
		<el-form :model="inputmodel" status-icon :rules="rules" ref="inputmodel" style=" display: grid;
  grid-template-columns: auto auto; grid-column-gap: 0.5rem;grid-auto-flow: row dense;">
			<el-form-item v-for="(item,index) in dialog_span" :key="index" :label="item.name" :prop="item.model">
				<el-input v-model="inputmodel[`${item.model}`]" autocomplete="off" :disabled="true"></el-input>
			</el-form-item>
			<el-form-item label="状态" prop="time"><br>
				<el-radio v-model="inputmodel.status" label="2">拒绝</el-radio>
				<el-radio v-model="inputmodel.status" label="1">同意</el-radio>
			</el-form-item>

		</el-form>
		<div v-if="inputmodel.status == 2">
			<span>拒绝原因</span>
			<el-input style="margin-top: 1rem;" type="textarea" :rows="2" placeholder="请输入拒绝原因"
				v-model="inputmodel.no_reason">
			</el-input>
		</div>
		<div class="bottom_button">
			<el-button @click="qx(1)">取 消</el-button>
			<el-button type="primary" @click="qx()">确 定</el-button>
		</div>
	</div>
</template>

<script>
	import {
		contract_out_review
	} from "@/api/api.js"
	export default {
		data() {
			return {
				name: '',
				dialog_span: [{
					name: '合同编号',
					model: 'contract_num'
				}, {
					name: '类型',
					model: 'type'
				}, {
					name: '创建时间',
					model: 'create_time'
				}, {
					name: '合同到期时间',
					model: 'end_time'
				}, {
					name: '申请时间',
					model: 'apply_time'
				}, {
					name: '备注',
					model: 'remark'
				}, {
					name: '原因',
					model: 'reason'
				}],
				inputmodel: {
					id: '',
					status: '',
					no_reason: ''
				},
				rules: {},
			}
		},
		props: [
			"item"
		],
		methods: {
			qx(i) {
				console.log(this.inputmodel);
				let data = {
					id: this.inputmodel.id,
					status: this.inputmodel.status,
					no_reason: this.inputmodel.no_reason
				}
				if (i != 1) {
					this.$refs['inputmodel'].validate((valid) => {
						if (valid) {
							contract_out_review(data).then(res => {
								this.Messages(res)
								if (res.status == 200) {
									this.inputmodel = {}
									this.$emit('changedia', false)
									this.$parent.$parent.$parent.contractlistcontractlist();
								}
							})
						}
					})
				} else {
					// this.inputmodel = {}
					this.$emit('changedia', false)
				}
			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			}
		},
		created() {
			this.rules[`status`] = [{
				required: true,
				message: '不能为空',
				trigger: 'blur'
			}]
			this.inputmodel = JSON.parse(JSON.stringify(this.item));
			this.inputmodel = JSON.parse(JSON.stringify(this.item));
			if (this.item.status == '拒绝') {
				this.inputmodel.status = '2'
				console.log(this.inputmodel.status);
			} else {
				this.inputmodel.status = '1'
			}
		},
		watch: {
			item: function(newVal, oldVal) {
				console.log('newVal', newVal);

				this.inputmodel = JSON.parse(JSON.stringify(this.item));
				if (this.item.status == '拒绝') {
					this.inputmodel.status = '2'
					console.log(this.inputmodel.status);
				} else {
					this.inputmodel.status = '1'
				}

			}
		}
	}
</script>

<style scoped>
	.bottom_button {
		margin: 20px 0;
		display: flex;
		justify-content: center;
	}

	.upload-demo {
		display: flex;
		align-items: center !important;

	}
</style>